import type { Program, Topic } from 'models';

import { Modal, message } from 'ui';
import { WithingsOrderPostForm, type WithingsOrderPostSubmitData } from './components';
import { useCreateWithingsOrderPostMutation } from './queries';

type P = {
  isOpened: boolean;
  onCancel: () => void;
  onRequestReturn?: () => void;
  onSuccess: () => Promise<void> | void;
  preSelectedProgramTopic?: Topic;
  program: Program;
};

const CreateWithingsOrderPost = ({
  isOpened,
  onCancel,
  onRequestReturn,
  onSuccess,
  preSelectedProgramTopic,
  program,
}: P) => {
  const { isPending, mutate } = useCreateWithingsOrderPostMutation();

  const onSubmit = (data: WithingsOrderPostSubmitData) => {
    mutate(
      { ...data, programId: program.id },
      {
        onError() {
          message.error('Something went wrong, please try again later.');
        },
        async onSuccess() {
          await onSuccess();
          message.success('Order was created.');
        },
      },
    );
  };

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title="Create Order" width="medium">
      <Modal.HugContent>
        <WithingsOrderPostForm
          loading={isPending}
          onRequestReturn={onRequestReturn}
          onSubmit={onSubmit}
          preSelectedProgramTopic={preSelectedProgramTopic}
          program={program}
          submitText="Create Post"
        />
      </Modal.HugContent>
    </Modal>
  );
};

export default CreateWithingsOrderPost;
